import {ThemeColorName} from '@di-nxt/components';

export const useLocationColoring = (
  _locationId: number,
): {color: ThemeColorName; opacity?: number} => ({
  color: 'background_location_008',
});
